export default __webpack_public_path__ + "static/media/download-google-play.5e04ab3a.svg";